import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import {
  initCloudWatchRum,
  trackCloudWatchRumPageVisit,
} from '../../cloudwatch-rum'

import { useAPIGetCloudwatchRumConfig } from 'api/apiHooks/useAPIGetCloudwatchRumConfig'
import { useAPIGetUserProfile } from 'api/apiHooks/useAPIGetUserProfile'

export const CloudWatchRumInitializer = () => {
  const location = useLocation()
  const { data: config } = useAPIGetCloudwatchRumConfig()
  const { data: userProfile } = useAPIGetUserProfile()

  useEffect(() => {
    if (!config || !userProfile) return
    initCloudWatchRum(config, userProfile.uuid, userProfile.email)
  }, [config, userProfile])

  useEffect(() => {
    trackCloudWatchRumPageVisit(
      `${location.pathname}${location.search}${location.hash}`
    )
  }, [location])

  return null
}
